import { InjectionToken } from '@angular/core';
import {
  AutoRegistrationConfig,
  AutoRegistrationRoutesConfig,
} from './models/auto-registration-config';

/** Route segment names for registration (used by router + `CONFIG`). */
export const registrationRoutesConfig: AutoRegistrationRoutesConfig = {
  LOGIN: 'login',
  SIGNUP: 'registration-cycle',
  RESET_PASSWORD: 'reset-password',
  VERIFY: 'verify',
  CHOOSE_BUSINESS: 'choose-business',
  SMART_SUGGESTIONS: 'smart-suggestions',
};

/** Injected registration app config (provided in `AppModule`). */
export const CONFIG = new InjectionToken<AutoRegistrationConfig>('RegistrationConfig');
